// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import ActiveUndistractorsSidebarController from './active_undistractors_sidebar_controller';
application.register('active-undistractors-sidebar', ActiveUndistractorsSidebarController);

import AdminDesktopAppController from './admin_desktop_app_controller';
application.register('admin-desktop-app', AdminDesktopAppController);

import AdminWebDomainController from './admin_web_domain_controller';
application.register('admin-web-domain', AdminWebDomainController);

import BarChartController from './bar_chart_controller';
application.register('bar-chart', BarChartController);

import BarFullBlueChartController from './bar_full_blue_chart_controller';
application.register('bar-full-blue-chart', BarFullBlueChartController);

import BarMidChartController from './bar_mid_chart_controller';
application.register('bar-mid-chart', BarMidChartController);

import BarMinimalChartController from './bar_minimal_chart_controller';
application.register('bar-minimal-chart', BarMinimalChartController);

import BeforeAfterCarouselController from './before_after_carousel_controller';
application.register('before-after-carousel', BeforeAfterCarouselController);

import BigBlueProductivityBarChartController from './big_blue_productivity_bar_chart_controller';
application.register('big-blue-productivity-bar-chart', BigBlueProductivityBarChartController);

import BootstrapCollapseExpanderController from './bootstrap_collapse_expander_controller';
application.register('bootstrap-collapse-expander', BootstrapCollapseExpanderController);

import BrowserController from './browser_controller';
application.register('browser', BrowserController);

import BrowserExtensionPopupController from './browser_extension_popup_controller';
application.register('browser-extension-popup', BrowserExtensionPopupController);

import CarouselMenuController from './carousel_menu_controller';
application.register('carousel-menu', CarouselMenuController);

import CollapsibleRightSidebarComponentController from './collapsible_right_sidebar_component_controller';
application.register('collapsible-right-sidebar-component', CollapsibleRightSidebarComponentController);

import ConsistentHeightCarouselController from './consistent_height_carousel_controller';
application.register('consistent-height-carousel', ConsistentHeightCarouselController);

import ContentPageTocController from './content_page_toc_controller';
application.register('content-page-toc', ContentPageTocController);

import DataWarningTooltipController from './data_warning_tooltip_controller';
application.register('data-warning-tooltip', DataWarningTooltipController);

import DelayedLoopVideoController from './delayed_loop_video_controller';
application.register('delayed-loop-video', DelayedLoopVideoController);

import DisabledInDemoController from './disabled_in_demo_controller';
application.register('disabled-in-demo', DisabledInDemoController);

import DonutChartController from './donut_chart_controller';
application.register('donut-chart', DonutChartController);

import ExtensionInstallTrackerController from './extension_install_tracker_controller';
application.register('extension-install-tracker', ExtensionInstallTrackerController);

import ExtensionStoreLinkController from './extension_store_link_controller';
application.register('extension-store-link', ExtensionStoreLinkController);

import FeatureShowcaseController from './feature_showcase_controller';
application.register('feature-showcase', FeatureShowcaseController);

import FeedbackController from './feedback_controller';
application.register('feedback', FeedbackController);

import FoldCueFadeController from './fold_cue_fade_controller';
application.register('fold-cue-fade', FoldCueFadeController);

import FullLineChartController from './full_line_chart_controller';
application.register('full-line-chart', FullLineChartController);

import GoogleGtagInjectionController from './google_gtag_injection_controller';
application.register('google-gtag-injection', GoogleGtagInjectionController);

import IntroAnimationController from './intro_animation_controller';
application.register('intro-animation', IntroAnimationController);

import LandingScrollController from './landing_scroll_controller';
application.register('landing-scroll', LandingScrollController);

import LazyLoadVideoController from './lazy_load_video_controller';
application.register('lazy-load-video', LazyLoadVideoController);

import LineChartController from './line_chart_controller';
application.register('line-chart', LineChartController);

import LineMinimalChartController from './line_minimal_chart_controller';
application.register('line-minimal-chart', LineMinimalChartController);

import LiteSignedInUserRedirectorController from './lite_signed_in_user_redirector_controller';
application.register('lite-signed-in-user-redirector', LiteSignedInUserRedirectorController);

import PauseAnimationOffscreenController from './pause_animation_offscreen_controller';
application.register('pause-animation-offscreen', PauseAnimationOffscreenController);

import PersistentTabsController from './persistent_tabs_controller';
application.register('persistent-tabs', PersistentTabsController);

import PlayOnViewController from './play_on_view_controller';
application.register('play-on-view', PlayOnViewController);

import ProfileBarMinimalChartController from './profile_bar_minimal_chart_controller';
application.register('profile-bar-minimal-chart', ProfileBarMinimalChartController);

import PromoExtensionVideoController from './promo_extension_video_controller';
application.register('promo-extension-video', PromoExtensionVideoController);

import RedGreenChartController from './red_green_chart_controller';
application.register('red-green-chart', RedGreenChartController);

import ReducedMotionVideoController from './reduced_motion_video_controller';
application.register('reduced-motion-video', ReducedMotionVideoController);

import ReplayableEffectController from './replayable_effect_controller';
application.register('replayable-effect', ReplayableEffectController);

import ReviewPromptController from './review_prompt_controller';
application.register('review-prompt', ReviewPromptController);

import RightSidebarMenuController from './right_sidebar_menu_controller';
application.register('right-sidebar-menu', RightSidebarMenuController);

import ScheduleController from './schedule_controller';
application.register('schedule', ScheduleController);

import SidebarRadioButtonCardComponentController from './sidebar_radio_button_card_component_controller';
application.register('sidebar-radio-button-card-component', SidebarRadioButtonCardComponentController);

import SidebarTabLinkController from './sidebar_tab_link_controller';
application.register('sidebar-tab-link', SidebarTabLinkController);

import SingleSubmitController from './single_submit_controller';
application.register('single-submit', SingleSubmitController);

import SiteBlockerController from './site_blocker_controller';
application.register('site-blocker', SiteBlockerController);

import SplitTestController from './split_test_controller';
application.register('split-test', SplitTestController);

import StopPropagationController from './stop_propagation_controller';
application.register('stop-propagation', StopPropagationController);

import SuggestionsCarouselController from './suggestions_carousel_controller';
application.register('suggestions-carousel', SuggestionsCarouselController);

import SuggestionsEnableDisableButtonController from './suggestions_enable_disable_button_controller';
application.register('suggestions-enable-disable-button', SuggestionsEnableDisableButtonController);

import SuggestionsMuteButtonController from './suggestions_mute_button_controller';
application.register('suggestions-mute-button', SuggestionsMuteButtonController);

import TourController from './tour_controller';
application.register('tour', TourController);

import TourLauncherController from './tour_launcher_controller';
application.register('tour-launcher', TourLauncherController);

import UndistractorExplainerModalController from './undistractor_explainer_modal_controller';
application.register('undistractor-explainer-modal', UndistractorExplainerModalController);

import UndistractorOptionsController from './undistractor_options_controller';
application.register('undistractor-options', UndistractorOptionsController);

import UndistractorSettingsPageRowController from './undistractor_settings_page_row_controller';
application.register('undistractor-settings-page-row', UndistractorSettingsPageRowController);

import UndistractorTabFilterController from './undistractor_tab_filter_controller';
application.register('undistractor-tab-filter', UndistractorTabFilterController);

import UninstallSurveyController from './uninstall_survey_controller';
application.register('uninstall-survey', UninstallSurveyController);

import VacatedStageController from './vacated_stage_controller';
application.register('vacated-stage', VacatedStageController);

import VideoProgressController from './video_progress_controller';
application.register('video-progress', VideoProgressController);
